<template>
  <span :class="['badge', badgeConfig.class]">
    <span class="badge-dot"></span>
    {{ badgeConfig.label }}
  </span>
</template>

<script>
const STATUS_MAP = {
  active:             { class: 'badge-success', label: 'Activa' },
  delivered:          { class: 'badge-success', label: 'Entregada' },
  ready:              { class: 'badge-success', label: 'Lista' },
  sent:               { class: 'badge-success', label: 'Enviada' },
  ready_for_pickup:   { class: 'badge-success', label: 'Lista para Pick-Up' },
  ready_for_delivery: { class: 'badge-success', label: 'Lista para Enviar' },
  pending:            { class: 'badge-warning', label: 'Pendiente' },
  in_process:         { class: 'badge-warning', label: 'En proceso' },
  inProcess:          { class: 'badge-warning', label: 'En proceso' },
  scheduled:          { class: 'badge-warning', label: 'Programada' },
  opened:             { class: 'badge-info',    label: 'Abierto' },
  clicked:            { class: 'badge-info',    label: 'Clicado' },
  sending:            { class: 'badge-info',    label: 'Enviando' },
  paused:             { class: 'badge-info',    label: 'Pausada' },
  excluded:           { class: 'badge-warning', label: 'Excluida' },
  draft:              { class: 'badge-neutral',  label: 'Borrador' },
  bounced:            { class: 'badge-error',   label: 'Rebotado' },
  unsubscribed:       { class: 'badge-neutral', label: 'Baja' },
  succeeded:          { class: 'badge-success', label: 'Exitoso' },
  requires_action:    { class: 'badge-warning', label: 'Requiere accion' },
  critical:           { class: 'badge-error',   label: 'Critico' },
  warning:            { class: 'badge-warning', label: 'Advertencia' },
  canceled:           { class: 'badge-error',   label: 'Cancelada' },
  suspended:          { class: 'badge-error',   label: 'Suspendida' },
  failed:             { class: 'badge-error',   label: 'Fallida' },
  failed_to_send:     { class: 'badge-error',   label: 'Fallida al Enviar' },
};

export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
  },
  computed: {
    badgeConfig() {
      const config = STATUS_MAP[this.status] || { class: 'badge-neutral', label: this.status };
      return {
        class: config.class,
        label: this.label || config.label,
      };
    },
  },
};
</script>
